import { defineAsyncComponent } from "vue";

const ConnectionsStatusDropdown = defineAsyncComponent(
  () => import("./ui/connections-status-dropdown.vue"),
);

export { ConnectionsStatusDropdown };
